<template>
  <!-- 大咖锦囊统计 -->
  <div class="jinnang-panel">
    <div class="panel-head">
      <div class="title-status">
        <h3 class="back-btn" @click="goback">
          <span class="icon-back"></span>
        </h3>
        <div class="title">{{ detail.title }}</div>
        <div class="status">{{ detail.statusStr }}</div>
      </div>
      <div class="date">创建日期 {{ formatTime(detail.createTime) }}</div>
    </div>
    <div class="panel-split"></div>
    <div class="panel-body">
      <div class="cell">
        <div class="cell-title">单价(元)</div>
        <div class="cell-value">{{ detail.price.toFixed(2) }}</div>
      </div>
      <div class="cell">
        <div class="cell-title">当前服务人数</div>
        <div class="cell-value">{{ detail.serviceNum }}</div>
      </div>
      <div class="cell">
        <div class="cell-title">剩余名额</div>
        <div class="cell-value">{{ detail.leftServiceNum }}</div>
      </div>
      <div class="cell">
        <div class="cell-title">已售</div>
        <div class="cell-value">{{ detail.saledNum }}</div>
      </div>
      <div class="cell">
        <div class="cell-title">已到期</div>
        <div class="cell-value">{{ detail.expiredNum }}</div>
      </div>
      <div class="cell-split"></div>
      <div class="cell">
        <div class="cell-title">总收益</div>
        <div
          :class="{
            'cell-value': true,
            c1: getSymbol(detail.glYield) > 0,
            c3: getSymbol(detail.glYield) <= 0
          }"
        >
          {{ detail.glYield }}
        </div>
      </div>
      <div class="cell">
        <div class="cell-title">日收益</div>
        <div
          :class="{
            'cell-value': true,
            c1: getSymbol(detail.dayYield) > 0,
            c3: getSymbol(detail.dayYield) <= 0
          }"
        >
          {{ detail.dayYield }}
        </div>
      </div>
      <div class="cell">
        <div class="cell-title">周收益</div>
        <div
          :class="{
            'cell-value': true,
            c1: getSymbol(detail.weekYield) > 0,
            c3: getSymbol(detail.weekYield) <= 0
          }"
        >
          {{ detail.weekYield }}
        </div>
      </div>
      <div class="cell">
        <div class="cell-title">月收益</div>
        <div
          :class="{
            'cell-value': true,
            c1: getSymbol(detail.monthYield) > 0,
            c3: getSymbol(detail.monthYield) <= 0
          }"
        >
          {{ detail.monthYield }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'AuthorJinNangStatistic',
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  watch: {},
  methods: {
    goback() {
      this.$router.push({ path: '/excl-author/jinnang' })
    },
    goto(router) {
      console.log(router)
      this.$router.push(router)
    },
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD')
    },
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    }
  }
}
</script>

<style lang="scss" scoped>
.jinnang-panel {
  width: 1200px;
  background-color: #ffffff;
  border-radius: 5px;
}

.panel-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  padding: 0px 30px;
}

.panel-split {
  height: 1px;
  background-color: #ebebeb;
  margin: 0px 30px;
}

.panel-body {
  display: flex;
  flex-flow: row nowrap;
  height: 105px;
  justify-content: flex-start;
  flex: 1 1 auto;
  align-items: center;
}

.cell-split {
  flex-basis: 1px;
  background-color: #ebebeb;
  height: 44px;
}

.title {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #262626;
}

.status {
  width: 60px;
  height: 22px;
  background-color: rgba(4, 107, 204, 0.1);
  border-radius: 5px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 22px;
  letter-spacing: 1px;
  text-align: center;
  color: #046bcc;
  margin-left: 11px;
}

.date {
  height: 14px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 14px;
  letter-spacing: 1px;
  color: #858585;
}

.title-status {
  display: flex;
  align-items: center;
}

.cell {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
}

.cell-title {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 14px;
  letter-spacing: 0px;
  color: #858585;
  margin-bottom: 12px;
}

.cell-value {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
}

.left {
  align-items: flex-start;
}

.right {
  align-items: flex-end;
}

.back-btn {
  padding-top: 24px;
  font-size: 16px;
  height: 50px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
  cursor: pointer;
}

.icon-back {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 2px;
  margin-right: 10px;
  background-color: #a3a29e;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 20%;
    margin-top: -9px;
    width: 8px;
    height: 8px;
    border-left: 2px solid #a3a29e;
    border-bottom: 2px solid #a3a29e;
    transform: rotate(45deg);
    transform-origin: 0 100%;
  }
}
</style>
